import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../LanguageProvider";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import Hero from "../Reutilizables/Hero/Hero";
import marianaImage from "../../assets/mariana about us.jpeg";
import person2 from "../../assets/person-2.jpg";
import person3 from "../../assets/person-3.jpg";
import person4 from "../../assets/person-4.jpg";
import person5 from "../../assets/person-5.jpg";
import orianaImage from "../../assets/Oriana Diaz.jpeg";
import "./About.css";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  const { language } = useLanguage();

  const people = [
    {
      name: "Mariana G. Tarifa",
      role: <>{t("aboutBoxText1")} · {t("aboutBoxText2")}<a href="https://atifonline.org/about-atif/" target="_blank" rel="noopener noreferrer">ATIF</a></>,
      image: marianaImage,
    },
    {
      name: "Julian Sieser",
      role: <>{t("aboutBoxText3")} · {t("aboutBoxText4")}<a href="https://gotitllc.com/" target="_blank" rel="noopener noreferrer">GotItLLC.com</a></>,
      image: person3,
    },
    {
      name: "Paulette Pagani",
      role: t("aboutBoxText5"),
      image: person4,
      linkedin: "https://www.linkedin.com/in/paulette-pagani-963a89263/",
    },
    {
      name: "Ma. Florencia Lasdica",
      role: `${t("aboutBoxText6")} · ${t("aboutBoxText7")}`,
      image: person5,
      linkedin: "https://www.linkedin.com/in/mariaflorencialasdica/",
    },
    {
      name: "Laura S. Tarifa",
      role: language === "en"
        ? "Consecutive/Simultaneous interpreter · Based in Las Vegas, Nevada"
        : "Intérprete simultánea y consecutiva · Con sede en Las Vegas, Nevada",
      image: person2,
    },
    {
      name: "Oriana Diaz De Vito",
      role: "Conference Interpreter",
      image: orianaImage,
      linkedin: "https://www.linkedin.com/in/oriana-diaz-de-vito?fbclid=PARlRTSAUQ92NwZG9mAmZkaWQWUOMSMVesuPRlKzUGvKp1cjeDgfkNXmV4dG4DYWVtAjEwAHNydGMGYXBwX2lkDzEyNDAyNDU3NDI4NzQxNAABp_qXmelXqqrhV1eOGZjUDowBBNhb0_iwqaLd8UxX5AfeOP_jKmUjXNzScpJq_aem_oA5hzmDffofpzY7qQwkp9Q",
    },
  ];

  return (
    <div className="app-shell about-page">
      <Header />
      <main className="page-main">
        <Hero className="about-hero">
          <div className="about-hero__content">
            <h1>{language === "en" ? "ABOUT US" : "QUIÉNES SOMOS"}</h1>
            <span />
            <h2>{language === "en" ? "A trusted team." : "Un equipo de confianza."}</h2>
            <h3>
              {language === "en" ? (
                <>Dedicated to <em>clear communication.</em></>
              ) : (
                <>Dedicado a una <em>comunicación clara.</em></>
              )}
            </h3>
          </div>
        </Hero>

        <section className="about-team-section">
          <div className="lh-container">
            <div className="team-grid">
              {people.map((person) => (
                <article className="team-card" key={person.name}>
                  <img src={person.image} alt={person.name} />
                  <div className="team-card__copy">
                    <h2>
                      {person.name}
                      {person.linkedin && (
                        <a
                          className="team-card__linkedin"
                          href={person.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`LinkedIn de ${person.name}`}
                          title={`LinkedIn de ${person.name}`}
                        >
                          <i className="bi bi-linkedin" aria-hidden="true" />
                        </a>
                      )}
                    </h2>
                    <p>{person.role}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default About;
